import TxpStatus from 'txp-data/lib/schema/TxpStatus';
import { SERVICE_RESERVATION_ENTITY_NAMES_MAP_VALUE } from 'owa-txp-common/lib/helpers/TxpCommonConstants';
import { logCalendarUsage } from 'owa-shared-analytics';
import { TxpDatapoint } from 'txp-data';
import LogNames from 'txp-data/lib/schema/telemetry/LogNames';
import TxpDataPointNames from '../../store/schema/telemetry/TxpDataPointNames';

export default function logCounterFactualDatapoint(
    entityNamesMap: number,
    txpStatusObject: TxpStatus,
    shouldShowCard: boolean
) {
    if (entityNamesMap === SERVICE_RESERVATION_ENTITY_NAMES_MAP_VALUE) {
        const txpDataPoint: TxpDatapoint = {
            [LogNames.entityNamesFlag]: entityNamesMap.toString(),
            [LogNames.tailoredEntityState]: txpStatusObject && txpStatusObject.state.toString(),
            [LogNames.isEntitySupported]: shouldShowCard.toString(),
        };

        logCalendarUsage(TxpDataPointNames.TxpExperimentTrigger, txpDataPoint);
    }
}
